import { useTranslation } from "react-i18next";
import { Star } from "lucide-react";

export const Marquee = () => {
  const { t } = useTranslation();
  const items = t("marquee.items", { returnObjects: true });
  const row = [...items, ...items];
  return (
    <div className="bg-black h-8 flex items-center overflow-hidden border-b border-[#D4AF37]/25" data-testid="editorial-marquee">
      <div className="if-marquee-track flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center text-white/70 text-[11px] font-medium tracking-wide">
                <span className="px-5">{item}</span>
                <Star className="w-3 h-3 text-[#D4AF37] fill-[#D4AF37]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
